export { useGetListCertificatesCollaborator } from './use-get-list-certificates-collaborator';
